import { Component } from '@angular/core';
import { ActablProductNames } from '../../core/models/user-profile.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  imports: [TranslateModule],
})
export class BannerComponent {
  protected readonly ActablProductNames = ActablProductNames;
}
